// AppSignal #5073: Choices.destroy() returns early only when `initialised` is
// false. A select that already has data-choice="active" (Turbo snapshot, or a
// previous instance that did not finish teardown) makes the constructor set
// initialised=true and return before it builds its DOM wrappers. destroy()
// then reads .element from those wrappers: containerOuter, input,
// passedElement, and dropdown in _removeEventListeners, then itemList and
// choiceList in clearChoices via clearStore. A missing wrapper throws
// TypeError: Cannot read properties of undefined (reading 'element').
// Stimulus reports that as "Error disconnecting controller".

const CHOICES_ELEMENTS = [
  "containerOuter",
  "input",
  "passedElement",
  "dropdown",
  "itemList",
  "choiceList"
]

export function destroyChoices(choices) {
  if (!choicesReady(choices)) return

  choices.destroy()
}

function choicesReady(choices) {
  return !!choices &&
    typeof choices.destroy === "function" &&
    choices.initialisedOK === true &&
    CHOICES_ELEMENTS.every((name) => hasElement(choices[name]))
}

function hasElement(wrapper) {
  return !!wrapper && !!wrapper.element
}
